'use client';

import { useLocale } from 'next-intl';
import type { ComponentProps } from 'react';
import { Link, usePathname } from '@/lib/routing';
import { getZoneFromHref, getZoneFromPath } from '@/lib/utils/zones';

interface ZoneLinkProps extends ComponentProps<'a'> {
  /** Locale-free path. */
  href: string;
}

/** Soft `<Link>` inside the current zone, a plain `<a>` with the locale across zones. */
export function ZoneLink({ href, ...rest }: ZoneLinkProps) {
  const locale = useLocale();
  const isSameZone = getZoneFromHref(href) === getZoneFromPath(usePathname());
  if (isSameZone) return <Link href={href} {...rest} />;
  return <a href={`/${locale}${href}`} {...rest} />;
}
